












































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Checkbox, CheckboxGroup, Button, Field, Popup, Toast } from "vant";
import CustomUploader from "@/components/CustomUploader.vue";
import NetErrorPage from "@/components/NetErrorPage.vue";

const createAccountModule = namespace("createAccount");

@Component({
  name: 'TaxResidentInfoPageOne',
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    customUploader: CustomUploader,
    NetErrorPage: NetErrorPage
  }
})
export default class TaxResidentInfoPageOne extends Vue {
  @createAccountModule.Getter("tax_place") getter_tax_place: any;
  @createAccountModule.Mutation("SAVE_TAX_PLACE_EXTRA") saveTaxPlaceExtra: any;
  @createAccountModule.Mutation("SAVE_TAX_PLACE") saveTaxPlace: any;
  @createAccountModule.Mutation("SAVE_COUNTRY_LIST")
  saveCountryList: any;

  tax_place: any = {
    choice: [],
    extra: []
  };

  // selectedNormalCountry = [];

  hot: any = [];
  normal: any = [];

  isLoading = true;
  requestFail = true;

  @Watch("getter_tax_place", { deep: true, immediate: true })
  watchTaxPlace(val) {
    this.tax_place = val;
  }
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get selectedNormalCountry() {
    return this.tax_place.extra.map(item => {
      return this.normal.find(country => {
        return item == country.id;
      });
    });
  }

  get isSubmitDisabled() {
    return !(this.tax_place.choice.length || this.tax_place.extra.length);
  }

  activated() {
    /**如果首次请求失败后再次进入重新请求 */
    if (this.requestFail) {
      this.getTaxPlaceList();
    }
  }

  getTaxPlaceList() {
    this.isLoading = true;
    (this as any).$apis
      .getTaxPlaceList()
      .then(res => {
        this.requestFail = false;
        const { hot, normal } = res;
        this.hot = hot;
        this.normal = normal;
        this.saveCountryList(res);
      })
      .catch(err => {
        this.requestFail = true;
        
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  handleDeteleCountryItem(item) {
    const index = this.selectedNormalCountry.indexOf(item);
    if (index > -1) {
      this.tax_place.extra.splice(index, 1);
    }
  }

  setTaxPlaceTemp() {}

  handleSaveResidentPlace() {
    const choiceLen = this.tax_place.choice.length || 0;
    const extraLen = this.tax_place.extra.length || 0;
    if (choiceLen + extraLen > 2) {
      return Toast(
        this.$t("open_account.tax_resident_info.page_one.toast_fail_text")
      );
    }
    (this as any).$apis
      .saveResidentPlace({
        tax_place: {
          ...this.tax_place
        }
      })
      .then(() => {
        this.setTaxPlaceTemp();
        this.$router.push({
          path: "/tax-resident-info/page-two",
          query: this.$route.query
        });
      })
      .catch(e => {
        
      });
  }
}
